require('../css/lastMinutes.css');
require("flatpickr/dist/flatpickr.css");


import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
let calendar = flatpickr(".flatpickr", {
    "locale": French,
    "onChange": function(selectedDates, dateStr, instance) {
        let year = this.selectedDates[0].getFullYear().toString();
        year = year.substr(-2);
        let month = this.selectedDates[0].getUTCMonth() + 1;
        month = month.toString();
        let day = this.selectedDates[0].getDate();
        day = day.toString();

        if(day < 10) {
            day = "0" + day;
        }

        if(month < 10) {
            month = "0" + month;
        }

        window.location = "/dernieres-minutes/" + year + month + day + "/";
    },
    maxDate: new Date().fp_incr(1), // 14 days from now
    minDate: subtractYears(new Date(), 1).fp_incr(1),
    wrap: true,
    disableMobile: "true"
});

function subtractYears(date, years) {
    date.setFullYear(date.getFullYear() - years);
    return date;
}

if (document.querySelector('.hier')) {
    function gettodaydate() {
        var d = new Date();
        let year = d.getFullYear().toString();
        year = year.substr(-2);
        let month = d.getUTCMonth() + 1;
        month = month.toString();
        let day = d.getDate();
        day = day.toString();

        if(day < 10) {
            day = "0" + day;
        }

        if(month < 10) {
            month = "0" + month;
        }
        var date = year + month + day;
        return date;
    }

    function gettomorrowdate() {
        var d = new Date();
        d.setDate(d.getDate() + 1);
        let year = d.getFullYear().toString();
        year = year.substr(-2);
        let month = d.getUTCMonth() + 1;
        month = month.toString();
        let day = d.getDate();
        day = day.toString();
        if(day < 10) {
            day = "0" + day;
        }
        if(month < 10) {
            month = "0" + month;
        }
        var date = year + month + day;
        return date;
    }

    function getyesterdaydate() {
        var d = new Date();
        d.setDate(d.getDate() - 1);
        let year = d.getFullYear().toString();
        year = year.substr(-2);
        let month = d.getUTCMonth() + 1;
        month = month.toString();
        let day = d.getDate();
        day = day.toString();
        if(day < 10) {
            day = "0" + day;
        }
        if(month < 10) {
            month = "0" + month;
        }
        var date = year + month + day;
        return date;
    }

    const hier = document.querySelector('.hier');
    const aujourdhui= document.querySelector('.aujourdhui');
    const demain = document.querySelector('.demain');
    var path = window.location.pathname.split('/');


    if (window.location.pathname == "/dernieres-minutes/" + gettodaydate() + "/" || window.location.pathname == "/programmes-courses/" ) {
        aujourdhui.classList.add('active');
    } else if (window.location.pathname == "/dernieres-minutes/" + gettomorrowdate() + "/") {
        demain.classList.add('active');
    } else if (window.location.pathname == "/dernieres-minutes/" + getyesterdaydate() + "/") {
        hier.classList.add('active');
    }
}